export default function(o, roll, horizontaOffsetCenter){

  var lang = o.store('lang')
  var project = roll.split('-')[0]

  var backLabel = o.util.getTranslation(o, 'back')
  var projectLabel = o.util.getTranslation(o, 'project')

  var currentMarker = null

  var backClick = function(){
    history.go(-1)
  }

  var goToProject = function(){
    history.pushState({}, '', `/box/${project}`)
    o.render(o)
  }

  var setCurrentMarker = function(marker){
    currentMarker = marker
  }

  var div =
    $('<div>')
    .css({
      display: 'flex',
      fontSize: o.fontSizeDef.s
    })
    .append([

      o.component.button(o, backLabel, backClick, 'caretLeft')
      .css({
        flex: '0 0 auto',
        pointerEvents: 'auto',
        marginLeft: horizontaOffsetCenter + 'px',
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

      o.component.button(o, projectLabel, goToProject, 'caretRight', true)
      .css({
        flex: '0 0 auto',
        pointerEvents: 'auto',
        marginRight: horizontaOffsetCenter + 'px',
      }),

    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/roll/center/center.js